module.exports = __webpack_public_path__ + "img/game_main_pc_214_off.6692fa9a.png";